import React, { useEffect } from "react";
import { useStateIfMounted } from "use-state-if-mounted";
import { RadialGauge } from "canvas-gauges";
import mqtt_topics from "./../../../mqtt/mqtt_topics";
import "./../../../css/app.css";
import useCheckMobileScreen from "./useCheckMobileScreen";

const MultiGauge = (props) => {
  let gaugeheightandwidth = useCheckMobileScreen() ? 65 : 150;
  const mac = mqtt_topics.choosenmac; //"0-5b-96";

  const [state, setState] = useStateIfMounted({
    values: ["0", "0", "0"], //["0", "0", "0"], //
    units: props.names, //["V RN", "V TN", "V SN"]
    value: 0, //300,
    unit: props.names[0],
    title: props.title,
    minValue: props.min,
    maxValue: props.max, //500
    limitover: 0, //300,
    limitunder: 0, //100,
    prelimitover: 0, //250,
    prelimitunder: 0, //150,
    scrollingindex: 0,
  });
  const target_live_reading_topic =
    mqtt_topics.fixed_topic_part +
    mac +
    "/" +
    props.category +
    mqtt_topics.Readings_topic +
    state.title;
  function listenforlivedata() {
    //console.log("target_live_reading_topic " + target_live_reading_topic);
    props.mqttClient.subscribe(target_live_reading_topic);
    props.mqttClient.on("message", handleMqttMessage);
  }

  function handleMqttMessage(topic, message) {
    if (topic === target_live_reading_topic) {
      try {
        message = JSON.parse(message.toString());
        setState((prevState) => {
          let tempscrollingindex = 0;
          if (document.getElementById(prevState.title + "_checkbox").checked) {
            // scrollingvoltages
            if (prevState.scrollingindex < prevState.values.length - 1) {
              tempscrollingindex = prevState.scrollingindex + 1;
            } else {
              tempscrollingindex = 0;
            }
          } else {
            tempscrollingindex = 0;
          }

          return {
            ...prevState,
            values: message.values || ["0", "0", "0"],
            maxValue: message.max || prevState.maxValue,
            minValue: message.min || prevState.minValue,
            limitover:
              message.limitover === undefined || message.limitover === "N"
                ? 0
                : message.limitover,
            limitunder:
              message.limitunder === undefined || message.limitunder === "N"
                ? 0
                : message.limitunder,
            prelimitover:
              message.prelimitover === undefined || message.prelimitover === "N"
                ? 0
                : message.prelimitover,
            prelimitunder:
              message.prelimitunder === undefined ||
              message.prelimitunder === "N"
                ? 0
                : message.prelimitunder,
            scrollingindex: tempscrollingindex,
          };
        });
      } catch (error) {
        // Handle the error
      }
    }
  }

  const calculatemajorTicks = (minValue, maxValue) => {
    const maxticksnumber = 6;
    let majorTicks = [];
    for (let i = 0; i < maxticksnumber; i++) {
      majorTicks[i] = Math.trunc(
        Math.round(
          (((+maxValue - +minValue) / (+maxticksnumber - 1)) * i + +minValue) *
            100
        ) / 100
      );
    }
    return majorTicks;
  };
  useEffect(() => {
    const redcolor = "rgba(200, 50, 50, .75)";
    const yellowcolor = "rgba(244, 155, 36, .75)";
    const blackcolor = "rgb(0,0,0)";
    const graycolor = "rgb(100,100,100)";

    //console.log("Use Effect Function state " + state.value);
    if (document.getElementById(state.title + "_canvas") != null) {
      new RadialGauge({
        renderTo: state.title + "_canvas",
        value: state.values[state.scrollingindex],
        width: gaugeheightandwidth,
        height: gaugeheightandwidth,
        //units: props.names[recursiveindex], //state.unit,
        minValue: state.minValue,
        maxValue: state.maxValue,
        majorTicks: calculatemajorTicks(state.minValue, state.maxValue),
        minorTicks: 3,
        strokeTicks: true,
        colorNeedle: blackcolor,
        colorNeedleEnd: blackcolor, //graycolor
        highlights: [
          {
            from: state.minValue,
            to: state.limitunder != 0 ? state.limitunder : state.minValue,
            color: redcolor,
          },
          {
            from: state.limitover != 0 ? state.limitover : state.maxValue,
            to: state.maxValue,
            color: redcolor,
          },
          {
            from:
              state.prelimitunder != 0
                ? state.limitunder != 0
                  ? state.limitunder
                  : state.minValue
                : state.prelimitunder,
            to: state.prelimitunder,
            color: yellowcolor,
          },
          {
            from: state.prelimitover,
            to:
              state.prelimitover != 0
                ? state.limitover != 0
                  ? state.limitover
                  : state.maxValue
                : state.prelimitover,
            color: yellowcolor,
          },
        ],
        colorPlate: "#fff",
        borderShadowWidth: 0,
        borders: false,
        needleType: "arrow",
        //needlestart: 75,
        //needleend: 99,
        needleWidth: 1.5,
        needleCircleSize: 7,
        animationDuration: 1500,
        animationRule: "linear",
        colorValueBoxShadow: false,
        colorValueTextShadow: false,
        needleShadow: false,
        valueBox: false,
        //valueInt: 1,
        //valueDec: 1,
        fontValueSize: 30,
        fontValueWeight: "bold",
        colorValueText: "#000",
        colorValueBoxRect: "#fff",
        colorValueBoxRectEnd: "#fff",
        colorValueBoxBackground: "#fff",
        colorValueBoxShadow: false,
        colorValueTextShadow: false,
      }).draw();
    }
  }, [
    state.unit,
    state.values,
    state.limitover,
    state.limitunder,
    state.prelimitover,
    state.prelimitunder,
    gaugeheightandwidth,
  ]);

  useEffect(() => {
    listenforlivedata();
  }, []);

  //when componenet unmount
  useEffect(
    () => () => {
      props.mqttClient.unsubscribe(target_live_reading_topic);
      props.mqttClient.removeListener("message", handleMqttMessage);
    },
    []
  );

  return (
    <div className="col">
      <div className="card text-center bg-light livecardsguages">
        <div className="card-header">{state.title}</div>
        <div className="card-body">
          <canvas id={state.title + "_canvas"}>Loading ...</canvas>
          <center>
            <label className="switch">
              <input
                className="switch-input"
                type="checkbox"
                id={state.title + "_checkbox"}
              />
              <span
                className="switch-label"
                data-on="Scroll"
                data-off="Scroll"
              ></span>{" "}
              <span className="switch-handle"></span>{" "}
            </label>
          </center>
        </div>
        <div className="card-footer">
          <h5>
            {state.values[state.scrollingindex] + " "}
            <strong
              style={{ fontSize: useCheckMobileScreen() ? "8px" : "12px" }}
            >
              {props.names[state.scrollingindex]}
            </strong>
          </h5>
        </div>
      </div>
    </div>
  );
};
export default MultiGauge;
